import i18n from 'i18next';

import { InputHTMLAttributes } from 'react';

import { ConditionOperatorType, ConditionVariableType, Dictionaries, InputType, originType } from '@enums';
import { getOptionListFromCatalog } from '@utils';

interface Field extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  value?: any;
  emptyValue?: any;
  inputType?: InputType;
  option?: any[];
  format?: any;
  previousActionKey?: string;
  description?: string;
  hints?: string;
}

export const routeRulesConditionField = (actionKey: ConditionVariableType): Field[] => {
  const schemeOption = getOptionListFromCatalog({
    name: Dictionaries.Operator,
    onlyOptions: [ConditionOperatorType.stringEqual, ConditionOperatorType.stringNotEqual],
  });
  const normalOptions = getOptionListFromCatalog({
    name: Dictionaries.Operator,
    hiddenOptions: [ConditionOperatorType.numberEqual],
  });
  const serverPortOptions = getOptionListFromCatalog({
    name: Dictionaries.Operator,
    onlyOptions: [ConditionOperatorType.numberEqual, ConditionOperatorType.numberNotEqual],
  });

  switch (actionKey) {
    case ConditionVariableType.URI:
      return [
        {
          name: 'operator',
          value: ConditionOperatorType.prefixMatches,
          inputType: InputType.Select,
          option: normalOptions,
        },
        {
          name: 'values',
          value: [{ value: '' }],
          emptyValue: '',
          inputType: InputType.Text,
          placeholder: i18n.t(`validation:format.${actionKey}`),
        },
      ];
    case ConditionVariableType.UserAgent:
      return [
        {
          name: 'operator',
          value: ConditionOperatorType.stringContainsWord,
          inputType: InputType.Select,
          option: normalOptions,
        },
        {
          name: 'values',
          value: [{ value: '' }],
          emptyValue: '',
          inputType: InputType.Text,
          placeholder: i18n.t(`validation:format.${actionKey}`),
        },
      ];
    case ConditionVariableType.ClientCountry:
    case ConditionVariableType.ClientAddress:
    case ConditionVariableType.HostName:
      return [
        {
          name: 'operator',
          value: ConditionOperatorType.stringEqual,
          inputType: InputType.Select,
          option: normalOptions,
        },
        {
          name: 'values',
          value: [{ value: '' }],
          emptyValue: '',
          inputType: InputType.Text,
          placeholder: i18n.t(`validation:format.${actionKey}`),
        },
      ];
    case ConditionVariableType.ServerPort:
      return [
        {
          name: 'operator',
          value: ConditionOperatorType.numberEqual,
          inputType: InputType.Select,
          option: serverPortOptions,
        },
        {
          name: 'values',
          value: [{ value: '' }],
          emptyValue: '',
          inputType: InputType.Text,
          placeholder: i18n.t(`validation:format.${actionKey}`),
        },
      ];
    case ConditionVariableType.Scheme:
      return [
        {
          name: 'operator',
          value: ConditionOperatorType.stringEqual,
          inputType: InputType.Select,
          option: schemeOption,
        },
        {
          name: 'values',
          value: [{ value: originType.HTTP }],
          emptyValue: originType.HTTP,
          inputType: InputType.Select,
          option: getOptionListFromCatalog({ name: Dictionaries.OriginType }),
        },
      ];

    default:
      return [];
  }
};
